import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { ChevronLeft, Plus, NotebookPen, Trash2, ChevronRight } from "lucide-react";
import api from "../lib/api";
import { useT } from "../context/LanguageContext";
import TopBar from "../components/TopBar";

export default function StudyPlanList() {
  const navigate = useNavigate();
  const t = useT();
  const [plans, setPlans] = useState(null);

  const load = () => api.get("/plans").then((r) => setPlans(r.data.plans)).catch(() => setPlans([]));
  useEffect(() => { load(); }, []);

  const del = async (e, id) => {
    e.stopPropagation();
    try { await api.delete(`/plans/${id}`); toast.success(t("Piano eliminato")); load(); } catch { toast.error(t("Errore")); }
  };

  if (!plans) return <div className="space-bg min-h-screen flex items-center justify-center text-white/60">{t("Caricamento...")}</div>;

  return (
    <div className="space-bg min-h-screen pb-20">
      <TopBar />
      <div className="max-w-lg mx-auto px-4 pt-5">
        <button onClick={() => navigate("/dashboard")} className="flex items-center gap-1 text-white/60 bouncy mb-4" data-testid="plans-back-btn">
          <ChevronLeft size={18} /> {t("Home")}
        </button>
        <div className="flex items-center justify-between mb-6">
          <h1 className="font-heading font-black text-3xl tracking-tight flex items-center gap-2"><NotebookPen style={{ color: "var(--violet)" }} /> {t("I miei piani")}</h1>
        </div>

        <button onClick={() => navigate("/plan/new")} className="w-full glass rounded-3xl p-5 mb-5 flex items-center justify-center gap-2 bouncy border-dashed border-2 border-white/20" data-testid="new-plan-btn">
          <Plus size={20} style={{ color: "var(--cyan)" }} /> <span className="font-heading font-bold">{t("Nuovo piano da appunti")}</span>
        </button>

        {plans.length === 0 ? (
          <p className="text-center text-white/50 mt-10">{t("Nessun piano ancora. Creane uno dai tuoi appunti! 📚")}</p>
        ) : (
          <div className="space-y-3">
            {plans.map((p, i) => (
              <motion.button key={p.plan_id} onClick={() => navigate(`/plan/${p.plan_id}`)}
                initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
                className="w-full glass rounded-2xl p-4 text-left bouncy flex items-center gap-3" data-testid={`plan-item-${p.plan_id}`}>
                <div className="flex-1">
                  <h3 className="font-heading font-bold tracking-tight">{p.title}</h3>
                  <p className="text-xs text-white/50 mt-1 line-clamp-1">{p.summary}</p>
                  <div className="mt-2 h-1.5 rounded-full bg-black/40 overflow-hidden w-40">
                    <div className="h-full rounded-full" style={{ width: `${p.total_levels ? (p.completed_levels / p.total_levels) * 100 : 0}%`, background: "var(--violet)" }} />
                  </div>
                  <span className="text-xs text-white/40 font-num">{p.completed_levels}/{p.total_levels} {t("livelli")}</span>
                </div>
                <Trash2 size={18} className="text-white/40 hover:text-red-400" onClick={(e) => del(e, p.plan_id)} data-testid={`plan-delete-${p.plan_id}`} />
                <ChevronRight size={18} className="text-white/40" />
              </motion.button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
